module.exports = __webpack_public_path__ + "img/slide-bar-off_06.1301f726.png";